import { inertNewTabHandle } from '../providers/IoContext';
export const makeNativeOpenNewTab = (openExternalUrl)=>(url)=>{
        void openExternalUrl(url);
        return inertNewTabHandle;
    };
export const makeOpenNewTab = (windowOpen)=>(url, opts)=>{
        if (opts === null || opts === void 0 ? void 0 : opts.trackable) {
            const win = windowOpen(url, '_blank');
            return {
                close: ()=>win === null || win === void 0 ? void 0 : win.close(),
                isClosed: ()=>{
                    var _ref;
                    return (_ref = win === null || win === void 0 ? void 0 : win.closed) !== null && _ref !== void 0 ? _ref : true;
                }
            };
        }
        windowOpen(url, '_blank', 'noopener,noreferrer');
        return {
            close: ()=>{},
            isClosed: ()=>true
        };
    };
